
/** Handles the progress of specified loading processes, calculates the overall loading progress and invokes onDone() when everything is loaded.*/
module.exports = function( needs, onDone, onProgress )
{
    this.needs = needs;
    this.onDone = onDone;
    this.onProgress = onProgress;

    //calculating how much portions of everything needs to load to inform about 100% (1.0) progress of load:
    this.fractionSum = 0;
    for (var needFractionIndex in this.needs) {
        if (this.needs.hasOwnProperty(needFractionIndex) !== true ) continue;
        this.fractionSum += this.needs[needFractionIndex].fraction;
    }

    this.loaded = function(id) {
        //looking for the specified need:
        for (var needIndex in this.needs) {
            var need = this.needs[ needIndex ];
            if (need.id === id) {
                need.loaded = true;
                break;
            }
        }

        //checking if all the needs was satisfied:
        var everythingLoaded = true;
        for (var checkingNeedIndex in this.needs) {
            if (this.needs.hasOwnProperty(checkingNeedIndex) !== true ) continue;
            if (this.needs[ checkingNeedIndex].loaded !== true) {
                everythingLoaded = false;
                break;
            }
        }
        if (everythingLoaded) {
            this.onDone();
            //to prevent any future calls from this.loaded() to work:
            this.onDone = undefined;
        }
    };

    /**
        * Inform this load handler about portion progress happening of something under id
        * @param id What is being loaded a bit.
        * @param portion What portion [0, 1] loaded of that.
        */
    this.progress = function(id, portion) {
        //set the progressed portion of specified need:
        for (var needIndex in this.needs) {
            var need = this.needs[needIndex];
            if (need.id === id) {
                need.portion = portion;
                break;
            }
        }

        //calculate the whole portion based on fractions of every need:
        var portionSum = 0;
        for (var needPortionIndex in this.needs) {
            var need = this.needs[needPortionIndex];
            var portion = 0;
            //if fully loaded then evaluate as fully progressed:
            if (need.loaded === true) {
                portion = 1.0;
            }
            else if (need.portion) {
                portion = need.portion;
                if (portion > 1.0) {
                    portion = 1.0;
                }
            }
            portionSum += portion * need.fraction;
        }

        this.onProgress( portionSum / this.fractionSum );
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/library/load_handler.js
// module id = 69
// module chunks = 0